import removeClass from 'remove-class';
import addClass    from 'add-class';
import hasClass    from 'has-class';

function initSearch() {
	const searchForm = document.querySelector('#search-form');
	const searchInput = searchForm.querySelector('.search-field');
	var blurring = false;

	searchForm.addEventListener('submit', (e) => {
		if (!blurring && !hasClass(searchForm, 'active')) {
			addClass(searchForm, 'active');
			searchInput.focus();
			e.preventDefault();
		}
		else if (!searchInput.value)
			e.preventDefault();

		blurring = false;
	});

	searchInput.addEventListener('focus', (e) => {
		if (!hasClass(searchForm, 'active'))
			addClass(searchForm, 'active');
	});

	searchInput.addEventListener('blur', (e) => {
		if (!searchInput.value && hasClass(searchForm, 'active')) {
			removeClass(searchForm, 'active');
			blurring = true;
		}
	});
}

function initNav() {
	const menuToggleBtn = document.querySelector('.site-header .menu-toggle-btn');
	const mainMenu = document.querySelector('.site-header .main-menu');

	menuToggleBtn.addEventListener('click', (e) => {
		if (hasClass(mainMenu, 'open')) {
			removeClass(mainMenu, 'open');
			mainMenu.setAttribute('aria-expanded', 'false');
			removeClass(menuToggleBtn, 'is-active');
		}
		else {
			addClass(mainMenu, 'open');
			mainMenu.setAttribute('aria-expanded', 'true');
			addClass(menuToggleBtn, 'is-active');
		}
	});

	window.addEventListener('resize', function() {
		clearTimeout(timeoutAriaExpanded);
		timeoutAriaExpanded = setTimeout(updateAriaExpanded, 100);
	});

	function updateAriaExpanded() {
		let isMenuExpanded = window.getComputedStyle(menuToggleBtn).display === 'none' ? 'true' : 'false';
		if (hasClass(mainMenu, 'open')) isMenuExpanded = 'true';
		mainMenu.setAttribute('aria-expanded', isMenuExpanded);
	}

	let timeoutAriaExpanded;
	updateAriaExpanded();
}

export function onLoad() {
	initSearch();
	initNav();
}



// WEBPACK FOOTER //
// ./assets/scripts/nav.js